import React from "react";
import { Tabs, Tag } from "antd";
import SidebarNav from "../sidebar";
import GlobalMaintenanceTab from "./GlobalMaintenanceTab";
import ScreenMaintenanceTab from "./ScreenMaintenanceTab";
import AppVersionTab from "./AppVersionTab";

const SYSTEM_SUMMARY = [
  {
    label: "Global Maintenance",
    color: "red",
    tab: "global",
    description:
      "Blocks the entire app for a platform (Android / iOS). Users see a full-screen maintenance gate and cannot do anything until you turn it off.",
  },
  {
    label: "Screen Maintenance",
    color: "orange",
    tab: "screen",
    description:
      "Gates a single screen (e.g. Spot, Withdrawals) without affecting the rest of the app. Users can still navigate elsewhere.",
  },
  {
    label: "App Version",
    color: "blue",
    tab: "version",
    description:
      "Controls update prompts. Soft update = dismissible nudge. Force update = hard block until the user installs the new build. Takes effect within ~60 s.",
  },
];

const TAB_ITEMS = [
    {
        key: "global",
        label: "Global Maintenance",
        children: <GlobalMaintenanceTab />,
    },
    {
        key: "screen",
        label: "Screen Maintenance",
        children: <ScreenMaintenanceTab />,
    },
    { key: "version", label: "App Version", children: <AppVersionTab /> },
];

const MaintenanceMode = () => {
  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid" style={{ padding: 24 }}>
          <h3>Maintenance &amp; App Updates</h3>

          {/* Quick-reference summary so admins know which tab to use */}
          <div
            style={{
              display: "flex",
              gap: 12,
              flexWrap: "wrap",
              marginBottom: 24,
              maxWidth: 1100,
            }}
          >
            {SYSTEM_SUMMARY.map((s) => (
              <div
                key={s.tab}
                style={{
                  flex: "1 1 280px",
                  background: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: 8,
                  padding: "12px 16px",
                }}
              >
                <Tag color={s.color} style={{ marginBottom: 6 }}>
                  {s.label}
                </Tag>
                <div style={{ fontSize: 12.5, color: "#444", lineHeight: 1.6 }}>
                  {s.description}
                </div>
              </div>
            ))}
          </div>

          {/* destroyInactiveTabPane keeps only the active tab mounted, so the
              two idle tabs don't run their initial loads until first opened. */}
                    <Tabs
                        defaultActiveKey="global"
                        items={TAB_ITEMS}
                        destroyInactiveTabPane
                    />
                </div>
            </div>
        </>
    );
};

export default MaintenanceMode;
